export const MAX_NUMBER_OF_WHEELCHAIR_COMPANIONS = 1;
export const MAX_NUMBER_OF_NON_WHEELCHAIR_COMPANIONS = 3;
export const MAX_NUMBER_PAX_NON_GROUP = 9;
export const MAX_NUMBER_PAX_GROUP = 99;

export const GENERAL_TYPE = 'GENERAL';
export const ACCESSIBLE_TRAVEL_TYPE = 'ACCESSIBLE_TRAVEL';
export const ANIMALS_ASSISTANCE_TYPE = 'ANIMALS_ASSISTANCE';
export const BLOCKED_SEATS_TYPE = 'BLOCKED_SEAT';
export const EVACUATION_CHAIR_TYPE = 'EVACUATION_CHAIR';
